import React, { Component, Fragment } from 'react';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image, Font, BlobProvider, PDFDownloadLink } from '@react-pdf/renderer';
import utils from '../../../../../ProducaoEP/utils/utils';
import utilsExportSTI from '../../../../../../utils/utilsExportSTI';
import calculo from './calculo';

export default class ContentPDFDinamico extends Component {

    constructor(props) {
        super(props);

        this.state = {
            styles: StyleSheet.create(utilsExportSTI.styles)
        };

    }

    async componentDidMount() {

        Font.register({
            family: 'Oswald',
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
        });

    }

    HeaderLista = (styles) => {
        let { radioChecked, ultimoMesApurado, mesSelecionado } = utilsExportSTI.formataMes(this.props)

        return (
            <Fragment>
                <Text style={styles.header} fixed>
                    {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                </Text>
                <Image
                    style={styles.logotipo}
                    src="/assets/images/senai_logo_cor.png"
                />
                <Text style={styles.titleHeader}>SENAI - SERVIÇO NACIONAL DE APRENDIZAGEM INDUSTRIAL</Text>
                <Text style={styles.titleHeader}>GEST - GERÊNCIA EXECUTIVA DE GESTÃO ESTRATÉGICA</Text>
                <Text style={styles.titleHeader}>UNIPLAN - UNIDADE DE PLANEJAMENTO</Text>
                <Text style={styles.space}></Text>
                <Text style={styles.title}>Relatório SIGEM</Text>
                <Text style={styles.title}>STI</Text>
                <Text style={styles.author}>{new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}</Text>
                <Text style={{ marginTop: 60 }}></Text>

                <View style={styles.resumoRow}>
                    <View>
                        <Text style={styles.resumoChave}>Mês Selecionado:</Text>
                    </View>
                    <View>
                        <Text style={styles.resumoValor}> { mesSelecionado }</Text>
                    </View>
                </View>

                <View style={styles.resumoRow}>
                    <View>
                        <Text style={styles.resumoChave}>Último mês apurado (realizado):</Text>
                    </View>
                    <View>
                        <Text style={styles.resumoValor}>{ ultimoMesApurado }</Text>
                    </View>
                </View>

                <View style={styles.resumoRow}>
                    <View>
                        <Text style={styles.resumoChave}>Tipo:</Text>
                    </View>
                    <View>
                        <Text style={styles.resumoValor}>{ radioChecked }</Text>
                    </View>
                </View>

                <View style={styles.resumoRow}>
                    <View>
                        <Text style={styles.resumoChave}>Período:</Text>
                    </View>
                    <View>
                        <Text style={styles.resumoValor}>{ `Janeiro / ${mesSelecionado}` }</Text>
                    </View>
                </View>

            </Fragment>
        )
    }

    TabelaRealizados = (styles, realizado, unidade, total) => {
        let modalidades = realizado.modalidades;
        let mesReferencia = <Text style={styles.textCaptalize}>{ `( ${utilsExportSTI.exibeMes(this.props)} )` }</Text>
        let mesReferenciaRealizado = <Text style={styles.textCaptalize}>{ `( ${utilsExportSTI.exibeMes(this.props, true)} )` }</Text>
        return (
            <Fragment>
                <View style={styles.table} break>

                    <View style={styles.tableRowUnidadeHeader}>
                        <Text style={styles.unidadeHeader}>{utilsExportSTI.retiraCodigoUnidade(unidade)}</Text>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderMetaRealizadoModalidades}>
                            <Text style={styles.tableCellMetaRealizadoHeader}></Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Matrículas</Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Horas</Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderMetaRealizadoModalidades}>
                            <Text style={styles.tableCellMetaRealizadoHeader}></Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader1}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Meta {mesReferencia} </Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Realizado {mesReferenciaRealizado}</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader1}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Meta {mesReferencia}</Text>
                        </View>
                        <View style={styles.tableColMetaRealizadoHeader2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Realizado {mesReferenciaRealizado}</Text>
                        </View>
                    </View>

                    <View style={styles.tableRow}>
                        <View style={styles.tableColHeaderModalidades}>
                            <Text style={styles.tableCellHeader}>Modalidades</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>%</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Não-Regimental</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Pagas</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>Total</Text>
                        </View>
                        <View style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>%</Text>
                        </View>
                    </View>
                    {
                        Object.keys(modalidades).map(modalidade => {
                            let meta = modalidades[modalidade]['meta'];
                            let realizado = modalidades[modalidade]['realizado'];
                            let totalMetaMatriculas = meta["matricula_pago"] + meta["matricula_nao_regimental"] + meta["matricula_regimental"]
                            let totalRealizadoMatriculas = realizado["matricula_pago"] + realizado["matricula_nao_regimental"] + realizado["matricula_regimental"]
                            let totalMetaHoras = meta["hora_pago"] + meta["hora_nao_regimental"] + meta["hora_regimental"]
                            let totalRealizadoHoras = realizado["hora_pago"] + realizado["hora_nao_regimental"] + realizado["hora_regimental"]

                            // verifica modalidades com valores zerados para omitir a visualização
                            let valoresZerados = totalMetaMatriculas + totalRealizadoMatriculas + totalMetaHoras + totalRealizadoHoras
                            if(valoresZerados === 0) return;
                            
                            return (
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColModalidades}>
                                        <Text style={styles.tableCellModalidades}>{modalidade}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaMatriculas, totalRealizadoMatriculas)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalMetaHoras)}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_nao_regimental'])}</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_pago'])}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoHoras)}</Text>
                                    </View>
                                    <View style={styles.tableColTotal}>
                                        <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaHoras, totalRealizadoHoras)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    {this.exibeTotais(styles, total[unidade])}
                </View>
                <View>
                    <Text style={styles.tableCell}>* Observações: {utilsExportSTI.exibeObservacao(this.props)}</Text>
                </View>
            </Fragment>
            
        )
    }

    exibeTotais = (styles, totais) => {
        let { meta, realizado } = totais;
        let totalMetaMatriculas = meta["matricula_pago"] + meta["matricula_nao_regimental"] + meta["matricula_regimental"]
        let totalRealizadoMatriculas = realizado["matricula_pago"] + realizado["matricula_nao_regimental"] + realizado["matricula_regimental"]
        let totalMetaHoras = meta["hora_pago"] + meta["hora_nao_regimental"] + meta["hora_regimental"]
        let totalRealizadoHoras = realizado["hora_pago"] + realizado["hora_nao_regimental"] + realizado["hora_regimental"]
        let viewTotais =  (
            <View style={styles.tableRowTotais}>
                <View style={styles.tableColModalidades}>
                    <Text style={styles.tableCellModalidades}>{}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['matricula_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalMetaMatriculas)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['matricula_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoMatriculas)}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaMatriculas, totalRealizadoMatriculas)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(meta['hora_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalMetaHoras)}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_nao_regimental'])}</Text>
                </View>
                <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{utils.formataNumero(realizado['hora_pago'])}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataNumero(totalRealizadoHoras)}</Text>
                </View>
                <View style={styles.tableColTotal}>
                    <Text style={styles.tableCell}>{utils.formataPercentualExport(totalMetaHoras, totalRealizadoHoras)}</Text>
                </View>
            </View>
        )
        return viewTotais
    }

    calculaPercentual = (meta, realizado) => calculo.calculaPercentual(meta, realizado)

    verificaColuna = (categoria) => calculo.verificaColuna(categoria)

    verificaValorTotalCategoria = (linhaAtuacao, valor, tipo) => {
        let { meses, mesSelecionado, mesSelecionadoRealizado, isAcumulado } = this.props
        return calculo.verificaValorTotalCategoria(linhaAtuacao, valor, tipo, { meses, mesSelecionado, mesSelecionadoRealizado, isAcumulado })
    }

    retornarCategorias = () => calculo.retornarCategorias()

    verificaCabecalhoAreaAtuacao = (area, styles) => calculo.verificaCabecalhoAreaAtuacao(area, styles)

    exibeDados = (metas, realizados, unidade) => {
        let { styles } = this.state
        let { meses, mesSelecionado, mesSelecionadoRealizado } = this.props
        let indiceMes = meses.indexOf(mesSelecionado)
        let indiceMesRealizado = meses.indexOf(mesSelecionadoRealizado)
        // let modalidades = Object.keys({...metas.modalidades, ...realizados.modalidades});
        let modalidades = this.retornarCategorias();
        
        let viewTotais = []
        
        for (const modalidade of modalidades) {
            let meta, realizado, valorMeta, valorRealizado, valorMetaRelatorios, valorRealizadoRelatorios;
            try {
                
                meta = metas.modalidades[modalidade]
                realizado = realizados.modalidades[modalidade]
                if(meta === undefined) continue
                valorMeta = this.verificaValorTotalCategoria(modalidade, meta, 'meta')
                valorRealizado = this.verificaValorTotalCategoria(modalidade, realizado, 'realizado')
                valorMetaRelatorios = meta['relatoriosELaudos'][indiceMes]
                valorRealizadoRelatorios = realizado['relatoriosELaudos'][indiceMesRealizado]

            } catch (error) {}

            let [estiloColModalidade, estiloCol] = this.verificaCabecalhoAreaAtuacao(modalidade, styles);

            let view = (
                <Fragment>

                    <View style={styles.tableRow}>
                        <View style={estiloColModalidade}>
                            <Text style={styles.tableCellModalidades}>{modalidade}</Text>
                        </View>
                        <View style={estiloCol}>
                            <Text style={styles.tableCell}>{modalidade === 'Metrologia' ? null: utils.formataNumero(valorMeta)}</Text>
                        </View>
                        <View style={estiloCol}>
                            <Text style={styles.tableCell}>{modalidade === 'Metrologia' ? null: utils.formataNumero(valorRealizado)}</Text>
                        </View>
                        <View style={estiloCol}>
                            <Text style={styles.tableCell}>{modalidade === 'Metrologia' ? null: this.calculaPercentual(valorMeta, valorRealizado)}</Text>
                        </View>
                    </View>
                    {
                        modalidade === 'Ensaios' || modalidade === 'Calibração' ?
                            <View style={styles.tableRow}>
                                <View style={estiloColModalidade}>
                                    <Text style={styles.tableCellModalidades}>{'Relatórios/Laudos'}</Text>
                                </View>
                                <View style={estiloCol}>
                                    <Text style={styles.tableCell}>{utils.formataNumero(valorMetaRelatorios)}</Text>
                                </View>
                                <View style={estiloCol}>
                                    <Text style={styles.tableCell}>{utils.formataNumero(valorRealizadoRelatorios)}</Text>
                                </View>
                                <View style={estiloCol}>
                                    <Text style={styles.tableCell}>{this.calculaPercentual(valorMetaRelatorios, valorRealizadoRelatorios)}</Text>
                                </View>
                            </View>
                            :
                            null
                    }
                </Fragment>
            )
            
            viewTotais.push(view)

        }

        let page = (
            <Fragment>
                <View style={styles.table} break>

                    <Image
                        style={styles.logotipo}
                        src="/assets/images/senai_logo_cor.png"
                    />
                    <Text style={styles.space}></Text>

                    <View style={styles.tableRowUnidadeHeader}>
                        <Text style={styles.unidadeHeader}>{unidade}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableColCabecalho1}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Áreas de Atuação</Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Meta </Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>Realizado</Text>
                        </View>
                        <View style={styles.tableColCabecalho2}>
                            <Text style={styles.tableCellMetaRealizadoHeader}>%</Text>
                        </View>
                    </View>
                    {viewTotais.map(v => v)}
                </View>
                <View>
                    <Text style={styles.tableCell}>* Observações: {utilsExportSTI.exibeObservacao(this.props)}</Text>
                </View>
            </Fragment>

        )

        return page
    }

    render() {
        let { styles } = this.state;
        let {
            metas,
            dados,
            meses,
            dadosTransformados,
            dadosTransformadosArray,
            mesSelecionado,
            radioChecked,
            isAcumulado,
            ultimoMesApurado
        } = this.props

        // let { realizados, metas, total, radioChecked, mesSelecionado, ultimoMesApurado } = this.props
        return (
            <Fragment>
                <Document>
                    <Page style={styles.body} orientation={"landscape"} >

                        {this.HeaderLista(styles)}

                        {/* {
                            realizados && Object.keys(realizados).map(realizado => {
                                return (this.TabelaRealizados(styles, realizados[realizado], realizados[realizado].unidade, total))
                            })
                        } */}
                        {
                            dados[ultimoMesApurado] && dados[ultimoMesApurado].map((valor, i) => {
                                let sigla = valor.unidade;
                                if(sigla === 'IST SENAI em Tecnologia em Automação Industrial') return
                                let indice = metas.findIndex((nome) => nome.unidade === valor.unidade);
                                let indiceRealizados = dadosTransformadosArray.findIndex((nome) => nome.unidade === valor.unidade);
                                let meta = metas[indice];
                                let realizados = dadosTransformadosArray[indiceRealizados];
                                return (
                                    <Fragment>
                                        {this.exibeDados(meta, realizados, sigla)}
                                    </Fragment>
                                )
                            })
                        }

                        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed />

                    </Page>
                </Document>
            </Fragment>
        );
    }
}
